/**
 * Featured homepage covers: blur-up crossfade after the image has loaded.
 */

function revealCoverImage(img) {
  if (img.classList.contains("is-cover-loaded")) {
    return;
  }

  const apply = () => {
    void img.offsetWidth;
    img.classList.add("is-cover-loaded");
  };

  const afterReady = async () => {
    if (img.decode && img.currentSrc) {
      try {
        await img.decode();
      } catch (_) {
        /* ignore */
      }
    }
    requestAnimationFrame(() => requestAnimationFrame(apply));
  };

  if (img.complete && img.naturalWidth > 0) {
    afterReady();
  } else {
    img.addEventListener("load", afterReady, { once: true });
  }
}

function bindCoverFade(img) {
  if (img.dataset.coverFadeBound === "true") {
    return;
  }
  img.dataset.coverFadeBound = "true";

  img.addEventListener("lazyloaded", () => revealCoverImage(img), { once: true });

  if (img.classList.contains("lazyloaded")) {
    revealCoverImage(img);
  }
}

export function bindFeaturedCoverFades(root = document) {
  const scope = root?.querySelector ? root : document;
  scope
    .querySelectorAll(".c-featured-project__cover .c-cover-media .o-image")
    .forEach(bindCoverFade);
}

export function initFeaturedCoverMedia(root = document) {
  const scope = root?.querySelector ? root : document;
  const covers = scope.querySelectorAll?.(
    ".c-featured-project__cover .lazyload"
  );

  if (!covers?.length) {
    return;
  }

  covers.forEach((img) => {
    img.setAttribute("data-expand", "1000");
  });

  bindFeaturedCoverFades(scope);

  if (!window.lazySizes?.loader) {
    return;
  }

  window.lazySizes.loader.checkElems(
    scope === document ? document.getElementById("main") : scope
  );
}
